import { html } from 'lit';

export const iconText = html`
  <svg
    width="64"
    height="64"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <image
      width="128"
      height="128"
      xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALkSURBVHgB7d2hbxNRHMDxXwlgmGBuArHABBjYLEFgSJYgMJMkVMyDxLH9B8yTcAI5MbOkjol5NswmtmViYsFsolMT5R7NDAktsL5eX77fTzKzmva9b+9y10t+rV4thHUjhGYAcAYAZwBwBgBnAHAGAGcAcAYAZwBwBgBnAHAGAGcAcAYAZwBwBgBnAHAGAGcAcAYAdzMyOu9extr6XlSdwzg+vQj9vdmZqWgv3o8P7ceRUyvXY+Fp8xeWN+uN74b+3/zcdHz9+CLuTt2OHLKdAlarXTd/BHYOzuqj6H7kki2Aje2T0GhUnaPIJVsAfvtHJ+daehUAZwBwBgBnAHBZbwQN09t6HeO0Wn2PlfpvkJX6xkvumy+/az3/Ek3xCABnAHAGAGcAcAYAZwBwBgBnAHAGAGcAcNkCmJ25M+T1qVBfk2uVLYD24oOBr796di/U1+RaZQvg7dLDP5ab/r/SfhLqa3KtsgWQnmJNT7OmR5uvPlw61KVf2r59elm/fivU1+RaZf05OH2Iz++fhoZraq28CoAzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzADgDgDMAOAOAMwA4A4AzALhWrxaFOu9extr6XlSdwzg+vYhxSrN90oyfNNenZMUGkDZ/YXmz3vhuNGl+bvrXwKc0+KlExZ4CVqvdxjc/2Tk4q49C+1GqYgPY2D6JSVF1jqJUxQYwCd/+K5P0Xv5VsQEMm7c7TiXPQS42gGHzdsep5DnIxQYwaN7uOJU+B7no+wDp2j9dDWzt/Bj7eTidgt7UR6F3S4+KnoNcdAC6Pm8FwxkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHAGQCcAcAZAJwBwBkAnAHA/QT7X5sgc7k6XwAAAABJRU5ErkJggg=="
    />
  </svg>
`;
